import type { FaireProductEntity } from "../../entity_types/product";

export const p_mrmzv8ccb9: FaireProductEntity = {
  token: "p_mrmzv8ccb9",
  type: "product",
  name: "Dead Sea Magnesium Oil Spray",
  brandToken: "b_cpmqxwgb5w",
  brandName: "Natural Elephant",
  imageUrl:
    "https://cdn.faire.com/fastly/7763fa424c4e34bc977c92c460cebaacdcc99c03c641ca430de8cb29ce714a2f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ed98b223ea77eeb702609893d3267cedd7ede38dad6a9a3c0a46a391c3a051cd.jpeg",
    "https://cdn.faire.com/fastly/34a3a040c4e680edfbc3d9222d322200eec4675dcae811893b340be72ac7ce84.jpeg",
    "https://cdn.faire.com/fastly/619f2a6b7433a89cf56fd4c491242b22d63c7f9b10ca45ae92b9d47289d56abe.jpeg",
    "https://cdn.faire.com/fastly/3fe35aac4a93db262c39fabe014b0180d2376b302180a3176ba0db3f0ce4afc5.jpeg",
    "https://cdn.faire.com/fastly/39d5caf97fd0c6ea191c39c12197c735fd1ce81f7208936e95ea3893f17d7182.jpeg",
    "https://cdn.faire.com/fastly/f9663c918e37258bfd9c889a6dd40fbde6e63d1e8cff0b561ea40a5a56cf79e5.jpeg",
  ],
  priceDollars: 6.93,
  description:
    "Pure magnesium chloride, dissolved into healing Dead Sea water is the best relief for muscle and joint pain. This topical Magnesium Oil is the fastest, safest, and most effective way to increase magnesium levels in your body, helping ease stress, headaches, and soreness.\n\nBenefits\n\n * Provides relief for symptoms of eczema, psoriasis and other skin ailments \n * Exfoliates and decreases dry skin and dandruff \n * Restores skin with essential minerals and vitamins \n * Detoxifies skin to help reduce cellulite \n * Provides anti-aging effects by decreasing wrinkling \n * Soothes arthritis pains and muscle tension \n * Helps decrease stress and promote healthy sleep \nKey Ingredients\n\nWATER, MARIS SAL (DEAD SEA) , MAGNESIUM CHLORIDE, CALCIUM CHLORIDE, SODIUM CHLORIDE, POTASSIUM CHLORIDE\n\nLearn more about the benefits of ingredients from the Dead Sea\n\nHow to Use\n\n * \nApply to clean skin to soothe muscle pains and soreness.",
  tags: [],
  msrpDollars: 16.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:57.540Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
